import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  CreateButton
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";
import { styles } from "./styles";
import "./index.css";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { SlugLinkButton } from "../components/button";

import { PageCreate as create, PageEdit as edit } from "./Create";

const PagesActions = ({ resource, basePath, refresh }) => (
  <CardActions style={styles.cardActionStyleSmall} className="pages-actions">
    <CreateButton basePath={basePath} />
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);

export const PageCreate = create;
export const PageEdit = edit;

export const PagesList = props => (
  <List
    {...props}
    actions={<PagesActions />}
    title={<IconTitle icon="pages" title={"resources.pages.title"} />}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }}>
      <TextField label="resources.pages.fieldList.name" source="name" />
      <DateField
        label="resources.pages.fieldList.create_at"
        source="created_at"
      />
      <EditButton label="" style={{ textAlign: "right" }} />
      <SlugLinkButton label="" url="pages" />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/pages/index.js